const ar = {
  common: {
    langToggle: "EN",
  },
  navbar: {
    items: ["الرئيسية", "الخدمات", "الباقات", "من نحن", "تواصل معنا"],
  },
  home: {
    heroSlides: [
      {
        title: "نساعدك في نمو أعمالك",
        description: "نقدم مجموعة متكاملة من الخدمات التسويقية.",
      },
      {
        title: "زيادة العملاء بذكاء",
        description: "استراتيجيات تسويق رقمية مخصصة لكل مطعم.",
      },
      {
        title: "حملات مبتكرة ومؤثرة",
        description: "نحوّل أفكارك إلى حملات رقمية جذابة.",
      },
    ],
    servicesCarousel: {
      title: "خدماتنا",
      more: "المزيد من الخدمات",
    },
    valuesPreview: {
      title: "من نحن وما نسعى إليه",
      subtitle: "ما نؤمن به وما نطمح لتحقيقه",
      cards: [
        {
          icon: "eye",
          title: "رؤيتنا",
          desc: "أن نصبح الشريك الأول لأصحاب المطاعم والكافيهات في النجاح الرقمي ونحوّل أفكارهم إلى حملات تسويقية مبتكرة تحقق نتائج ملموسة.",
        },
        {
          icon: "mail",
          title: "رسالتنا",
          desc: "تقديم حلول تسويقية متكاملة ومخصصة لكل مطعم وكافيه من التسويق الرقمي إلى إدارة الحملات الإعلانية لزيادة العملاء وتعزيز العلامة التجارية.",
        },
        {
          icon: "target",
          title: "أهدافنا",
          desc: "نسعى لجعل كل مطعم وكافيه يتألق رقميًا ويصل لأكبر عدد من العملاء بسهولة وذكاء.",
        },
      ],
    },
    faq: {
      title: "الأسئلة الشائعة",
      items: [
        {
          q: "ما هي الخدمات التي تقدمها خُبزة؟",
          a: "نقدم إدارة وسائل التواصل الاجتماعي، استشارات تسويقية، الترويج عبر المؤثرين، وحلول تسويقية متكاملة لمساعدتك في نمو أعمالك.",
        },
        {
          q: "كيف يمكنني طلب باقة أو خدمة؟",
          a: "اختر الخدمة أو الباقة المناسبة بالضغط على الزر وسيتم توجيهك مباشرة إلى نموذج الطلب لإكمال التفاصيل وحجز الخدمة.",
        },
        {
          q: "هل تقدمون استشارات مجانية؟",
          a: "نعم، نقدم استشارة أولية مجانية لتحديد احتياجاتك قبل اختيار الباقة المناسبة.",
        },
      ],
    },
  },
  services: {
    cards: [
      {
        title: "إدارة وسائل التواصل الاجتماعي",
        desc: "سنقوم بإدارة حساباتك في وسائل التواصل الاجتماعي لزيادة التفاعل ونمو جمهورك.",
        details: [
          "جدولة المنشورات اليومية",
          "تحليل أداء المنشورات",
          "التفاعل مع الجمهور والردود",
          "تقرير شهري عن النتائج",
        ],
      },
      {
        title: "استشارات تسويقية",
        desc: "نقدم استشارات تسويقية مخصصة لمساعدتك في وضع استراتيجيات فعالة لتحقيق أهدافك التسويقية.",
        details: [
          "تحليل السوق والمنافسين",
          "وضع استراتيجيات تسويقية مفصلة",
          "تقديم نصائح لتحسين الحملات الإعلانية",
        ],
      },
      {
        title: "الترويج عبر المؤثرين",
        desc: "نقوم بالترويج لمنتجاتك أو خدماتك عبر المؤثرين المناسبين لزيادة وتحقيق نتائج أفضل.",
        details: [
          "اختيار المؤثر المناسب للجمهور المستهدف",
          "إدارة الحملات مع المؤثرين",
          "تحليل نتائج الترويج ورفع التقارير",
        ],
      },
      {
        title: "حملات إعلانية",
        desc: "نقوم بإنشاء وتنفيذ حملات إعلانية فعالة على منصات TikTok وInstagram لزيادة الوعي بالعلامة التجارية وتحقيق نتائج ملموسة.",
        details: [
          "تصميم إعلانات جذابة",
          "استهداف الجمهور الصحيح",
          "متابعة الأداء وتحسين النتائج",
          "تقديم تقارير دورية مفصلة",
        ],
      },
      {
        title: "إعداد خطة تسويقية",
        desc: "نقدم خطة تسويقية شاملة تساعدك على تحديد الجمهور المستهدف ووضع استراتيجيات فعالة لتحقيق أهدافك التسويقية.",
        details: [
          "تحديد الأهداف التسويقية",
          "وضع خطة محتوى وجدولة الحملات",
          "تقدير الميزانية والموارد المطلوبة",
        ],
      },
      {
        title: "تصميم الشعارات والهوية البصرية",
        desc: "نقدم خدمات تصميم الشعارات والهوية البصرية لمساعدتك على بناء هوية قوية ومحترفة لعلامتك التجارية.",
        details: [
          "تصميم شعار مبتكر وجذاب",
          "اختيار الألوان والخطوط المتناسقة",
          "تطبيق الهوية على كافة المواد التسويقية",
        ],
      },
    ],
    orderButton: "طلب الخدمة",
  },
  packages: {
    heroTitle: "الباقات",
    heroText:
      "اختر الباقة اللي تناسب مرحلتك الحالية وخلّنا نبني حضورك الرقمي بشكل احترافي.",
    sectionTitle: "اختر الباقة المناسبة",
        mostPopular: "الأكثر طلبًا",
    sectionSubtitle: "باقات مرنة — نحددها حسب احتياج مشروعك.",
    cards: [
      {
        name: "باقة الانطلاقة",
        desc: "حل متكامل لبدء حضور رقمي منظم يعكس هوية مشروعك باحترافية.",
        sections: [
          {
            summary: "تشمل الباقة",
            items: [
              "إدارة منصة واحدة (حسب اختيار العميل)",
              "تصميم هوية بصرية أساسية",
              "إعداد خطة تسويقية مبدئية",
              "استشارة تسويقية",
            ],
          },
          {
            summary: "النتيجة المتوقعة",
            items: [
              "حضور رقمي منظم يعكس احترافية مشروعك",
              "هوية واضحة تعزز ثقة العملاء",
              "بداية قوية مبنية على خطة مدروسة",
            ],
          },
        ],
        cta: "اطلب الباقة",
      },
      {
        name: "باقة النمو",
        desc: "مناسبة للعلامات التجارية التي ترغب في تحقيق نمو ملحوظ في التفاعل والمبيعات.",
        sections: [
          {
            summary: "تشمل الباقة",
            items: [
              "إدارة منصتين (حسب اختيار العميل)",
              "إعداد خطة تسويقية متقدمة",
              "حملات إعلانية مدفوعة",
              "خطة لرفع التفاعل والطلبات",
              "استشارة تطوير شهرية",
            ],
          },
          {
            summary: "النتيجة المتوقعة",
            items: [
              "زيادة التفاعل بشكل ملحوظ",
              "رفع عدد الاستفسارات والطلبات",
              "تحسين معدل تحويل المتابعين إلى عملاء",
            ],
          },
        ],
        cta: "اطلب الباقة",
      },
      {
        name: "باقة التوسع",
        desc: "باقة متقدمة توفر إدارة شاملة استراتيجية تسويق احترافية وتحليل تنافسي متكامل.",
        sections: [
          {
            summary: "تشمل الباقة",
            items: [
              "إدارة متعددة المنصات",
              "حملات إعلانية متقدمة",
              "الترويج عبر المؤثرين",
              "إعداد خطة تسويقية شاملة",
              "استشارات مستمرة",
            ],
          },
          {
            summary: "النتيجة المتوقعة",
            items: [
              "أقوى وتموضع تنافسي في السوق",
              "حملات مدروسة تقلل تكلفة الحصول على طلب",
              "تحسين مستمر بناءً على الأرقام والأداء",
            ],
          },
        ],
        cta: "اطلب الباقة",
      },
    ],
    noteTitle: "كيف نحدد الباقة المناسبة لك؟",
    noteText:
      "نبدأ بجلسة قصيرة نفهم فيها احتياج مشروعك وأهدافه وبعدها نجهز لك عرض مناسب حسب حجم العمل والخدمات المطلوبة.",
    bottomCtaTitle: "محتار أي باقة تناسبك؟",
    bottomCtaText: "خلّنا نساعدك ونرتّب لك خطة تناسب مشروعك.",
    bottomCtaBtn: "تواصل معنا الآن",
  },
  about: {
    heroTitle: "من نحن",
    heroText:
      "نحن فريق شغوف من المسوّقين والمبدعين نساعد المطاعم والكافيهات على النمو والتميّز في السوق الرقمي عبر استراتيجيات تسويق ذكية ومبتكرة.",
    missionTitle: "مهمتنا",
    missionLines: [
      "نختص بمساعدة المطاعم والكافيهات على النمو والتميز في السوق الرقمي.",
      "نؤمن بأن التسويق الذكي والمبتكر هو سر نجاح أي مشروع.",
      "نقدم حلولاً متكاملة تساعدكم على الوصول لجمهوركم وزيادة التفاعل.",
    ],
    valuesTitle: "قيمنا",
    values: [
      { title: "الابتكار", desc: "نقدم حلولاً إبداعية تميز عملاءنا.", icon: "zap" },
      { title: "الشغف", desc: "الشغف هو دافعنا للنجاح والتميّز.", icon: "heart" },
      { title: "التعاون", desc: "بروح الفريق نحقق أفضل النتائج.", icon: "users" },
      { title: "التميز", desc: "نلتزم بتقديم أعلى جودة في خدماتنا.", icon: "award" },
    ],
  },
  contact: {
    heroTitle: "تواصل معنا",
    heroText:
      "ارسل لنا تفاصيل مشروعك وسنتواصل معك بأقرب وقت لتحديد الخطوة القادمة",
    formTitle: "أرسل رسالة",
    formSubtitle: "املأ البيانات التالية وسنتواصل معك قريباً.",
    infoTitle: "بيانات التواصل",
    infoSubtitle: "يمكنك التواصل معنا مباشرة عبر:",
    followTitle: "تابعنا",
    placeholders: {
      name: "اكتب اسمك",
      phone: "05xxxxxxxxxx",
      email: "example@gmail.com",
      message: "اكتب رسالتك",
    },
    button: {
      send: "إرسال",
      sending: "جاري الإرسال...",
    },
    success: "✓ تم إرسال رسالتك بنجاح، سنتواصل معك قريباً.",
    errors: {
      nameRequired: "الرجاء إدخال اسمك.",
      phoneRequired: "الرجاء إدخال رقم الهاتف.",
      phoneInvalid: "رقم الهاتف يجب أن يكون 10 أرقام.",
      emailRequired: "الرجاء إدخال البريد الإلكتروني.",
      emailInvalid: "صيغة البريد الإلكتروني غير صحيحة.",
      messageRequired: "الرجاء كتابة رسالتك.",
    },
  },
  footer: {
    contactTitle: "تواصل معنا",
    address: "الرياض ، المملكة العربية السعودية",
    email: "info@nkubzah.sa",
    socialTitle: "تابعنا على وسائل التواصل الاجتماعي",
    linksTitle: "روابط سريعة",
    links: ["الرئيسية", "الخدمات", "الباقات", "من نحن", "تواصل معنا"],
    copyright: "&copy; 2026 Khubzah Solutions. All rights reserved.",
  },
  request: {  /* new for request form */
    title: "طلب خدمة أو باقة",
    desc:
      "يرجى ملء النموذج أدناه لطلب الخدمة التي ترغب بها، وسنقوم بالتواصل معك في أقرب وقت ممكن.",
    labels: {
      name: "الاسم الكامل:",
      email: "البريد الإلكتروني:",
      phone: "رقم الهاتف:",
      projectType: "نوع المشروع:",
      company: "اسم المشروع:",
      requestType: "اختر نوع الطلب:",
      notes: "ملاحظات إضافية:",
      services: "اختر الخدمات المطلوبة:",
      package: "اختر الباقة:",
    },
    placeholders: {
      name: "ادخل اسمك الكامل",
      email: "name@example.com",
      phone: "05xxxxxxxx",
      company: "اسم المشروع",
      notes: "اكتب ملاحظاتك...",
    },
    projectTypes: {
      default: "اختر نوع المشروع",
      restaurant: "مطعم - Restaurant",
      coffeeShop: "كافيه - Coffee Shop",
    },
    requestTypes: {
      services: "خدمات",
      packages: "باقات",
    },
    services: [
      "إدارة وسائل التواصل الاجتماعي",
      "استشارات تسويقية",
      "الترويج عبر المؤثرين",
      "إعداد خطة تسويقية",
      "حملات إعلانية",
      "تصميم الشعارات والهوية البصرية",
    ],
    packages: [
      "باقة الانطلاقة",
      "باقة النمو",
      "باقة التوسع",
    ],
    button: {
      send: "إرسال الطلب",
    },
    success: "✓ تم إرسال الطلب بنجاح، سنتواصل معك قريباً.",
    formError: "يجب تعبئة جميع الحقول المطلوبة.",
    errors: {
      nameRequired: "الرجاء إدخال الاسم الكامل.",
      emailRequired: "الرجاء إدخال البريد الإلكتروني.",
      emailInvalid: "صيغة البريد الإلكتروني غير صحيحة.",
      phoneRequired: "الرجاء إدخال رقم الهاتف.",
      phoneInvalid: "رقم الهاتف يجب أن يكون 10 أرقام.",
      projectTypeRequired: "الرجاء اختيار نوع المشروع.",
      companyRequired: "الرجاء إدخال اسم المشروع.",
      requestTypeRequired: "الرجاء اختيار نوع الطلب.",
      servicesRequired: "الرجاء اختيار خدمة واحدة على الأقل.",
      packageRequired: "الرجاء اختيار باقة واحدة.",
    },
  }, 
}; /* aa*/



export default ar;

